import React, { useCallback } from 'react'

import { Link } from 'react-router'

import SubscribeDialogCTA from '../../App/SubscribeDialogCTA'
import BannerSlideShow from '../../generic/BannerSlideShow'

function HomeBanner({
  banners,
  homeIsReady,
  isMobile,
  freeTrialBanner,
  isSubscribed,
  usedFreeTrial,
  bannerStatus
}) {
  const getMainTitle = useCallback(() => {
    if (isSubscribed)
      return freeTrialBanner.mainSubscribeTitle || 'Imagine. Learn. Create.'

    return freeTrialBanner.mainFreeTrialTitle || 'For Artists and Creators'
  }, [isSubscribed, freeTrialBanner])
  const getBackground = useCallback(() => {
    let background = ''
    if (freeTrialBanner && freeTrialBanner.bannerImage) {
      background = freeTrialBanner.bannerImage.normal
      if (isMobile) background = freeTrialBanner.bannerImage.mobile
    }
    return {
      backgroundImage: `url(${background})`
    }
  }, [freeTrialBanner, isMobile])

  return (
    <div className="banner-placeholder">
      {homeIsReady && banners?.length === 0 && bannerStatus && (
        <div className="subscribe-banner" style={getBackground()}>
          {!isSubscribed && (
            <div className="tagline big">
              <h3>
                {freeTrialBanner.topTitle ||
                  'Join the Premier Online Community'}
              </h3>
            </div>
          )}

          <h1 className={isSubscribed ? 'is-subscribed' : ''}>
            {getMainTitle()}
          </h1>

          {isSubscribed && (
            <div className="tagline is-subscribed">
              <h2>
                {freeTrialBanner.mainSubscribeTagline ||
                  "Online Courses with Hollywood's Master FX Artists"}
              </h2>
            </div>
          )}

          {!isSubscribed && !usedFreeTrial && (
            <h3>{freeTrialBanner.middleTitle || 'free 7-Day Trial'}</h3>
          )}

          {!isSubscribed ? (
            <SubscribeDialogCTA>
              <div className="btn -orange" style={{ marginTop: 24 }}>
                {!usedFreeTrial
                  ? freeTrialBanner.ctaFreeTrial || 'Start My Free Trial'
                  : freeTrialBanner.ctaSubscribe || 'Start subscription'}
              </div>
            </SubscribeDialogCTA>
          ) : (
            <Link to="/tutorials" className="btn -orange">
              View Courses
            </Link>
          )}

          {freeTrialBanner.bottomTitle && (
            <h3 className="new-courses">{freeTrialBanner.bottomTitle}</h3>
          )}
        </div>
      )}

      {homeIsReady && banners?.length > 0 && (
        <BannerSlideShow banners={banners} isMobile={isMobile} />
      )}
    </div>
  )
}

export default HomeBanner
